import { SuspendCompanyConfirmationWebComponent } from './component/SuspendCompanyConfirmationWebComponent';
import { WEB_COMPONENT_SUSPEND_COMPANY_CONFIRMATION } from '../../../webcomponents.constants';

export { SuspendCompanyConfirmationWebComponent };

window.customElements.define(WEB_COMPONENT_SUSPEND_COMPANY_CONFIRMATION, SuspendCompanyConfirmationWebComponent);
